import { Modal, Divider } from 'antd';
import AfspLoginFormError from './AfspLoginFormError';
import AfspLoginForm from './forms/AfspLoginForm';
import AfspForgotPasswordForm from './forms/AfspForgotPasswordForm';
import AfspLoginControls from './controls/AfspLoginControls';
import TsaWarningBanner from './TsaWarningBanner';


export default class extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { services, state: { login: { view, showLoginModal, loginButtonDisabled }}} = this.props;
        return (
            <Modal
                footer={null}
                centered={true}
                closable={false}
                width={450}
                visible={showLoginModal}
                bodyStyle={{ padding: '15px' }}
            >
                <div className='afsp-login-mask-shader' />
                <Divider style={{ margin: '0px 0px 15px' }}>
                    <span className='afsp-login-divider-title'>
                        {'FTSP Log In'}
                    </span>
                </Divider>
                <div>
                    <AfspForgotPasswordForm {...this.props} /> 
                    {view === 'login' ? <AfspLoginForm {...this.props} /> 
                    : ((() => {
                        if (!loginButtonDisabled) services.toggleAfspLoginButtonDisable();
                        return <AfspLoginFormError />;
                    })())}
                </div>
                <Divider type='horizontal' style={{ margin: '15px 0px' }} />
                <TsaWarningBanner/>   
                <Divider type='horizontal' style={{ margin: '15px 0px' }} />
                <div style={{ textAlign: 'right' }}>{
                    view === 'login' ? <AfspLoginControls {...this.props} />
                    : <AfspLoginControls {...this.props} />
                }</div>
            </Modal>
        )
    }
}